import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { DataTypeProvider } from "@devexpress/dx-react-grid";

import { ModalContext } from "../../webtracking/commons/modal";
import { PartStatus, PartStatusList } from "../../helpers/parts";
import PartStatusLog from "./PartStatusLog";

const PartStatusFormatter = ({ value, row }) => {
  const status = PartStatus[value];

  const { startModal } = useContext(ModalContext);

  return (
    <span
      onClick={() =>
        startModal(<PartStatusLog id={row.id} />, "Historial de status")
      }
      className={`tag ${status.color}`}
      title={status.label}
    >
      {status.key}
    </span>
  );
};

const PartStatusEditor = ({ value, onValueChange }) => (
  <div className="select">
    <select
      value={value}
      onChange={(event) => onValueChange(event.target.value)}
    >
      <option value="">Filter...</option>
      {PartStatusList.map((status) => (
        <option key={status.id} value={status.id}>
          {status.key}
        </option>
      ))}
    </select>
  </div>
);

const PartStatusTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={PartStatusFormatter}
    editorComponent={PartStatusEditor}
    {...props}
  />
);

const InvoiceFormatter = ({ value }) => {
  if (!value) {
    return null;
  }

  const host = process.env.REACT_APP_BACKEND_HOST;

  return <a href={`${host}api/invoices/${value.id}/download/`}>{value.name}</a>;
};

const ElapsedTimeFormatter = ({ value }) => {
  const now = new Date();
  const then = new Date(value);

  let delta = now - then;
  const delta_arr = [];
  const separators = [1000, 60, 60, 24, 5 * 365];
  separators.forEach((separator) => {
    delta_arr.push(delta % separator);
    delta = Math.floor(delta / separator);
  });

  return (
    <span title={value}>
      {delta_arr[4]} days {delta_arr[3]} hours
    </span>
  );
};

const InvoiceEditor = ({ value, onValueChange }) => (
  <div className="MuiInputBase-root MuiInput-root Editor-root-41 MuiInput-underline MuiInputBase-fullWidth MuiInput-fullWidth">
    <input
      type="text"
      placeholder="Filter..."
      className="MuiInputBase-input MuiInput-input Editor-input-40"
      value={value}
      onChange={(event) => onValueChange(event.target.value)}
    />
  </div>
);

const InvoiceTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={InvoiceFormatter}
    editorComponent={InvoiceEditor}
    {...props}
  />
);

const HeadFormatter = ({ value, row }) => (
  <Link to={`/backorder/${row.parent}`}>{value}</Link>
);

const HeadTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={HeadFormatter} {...props} />
);

const ElapsedTimeTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={ElapsedTimeFormatter} {...props} />
);

export {
  ElapsedTimeTypeProvider,
  PartStatusTypeProvider,
  InvoiceTypeProvider,
  HeadTypeProvider,
};
